import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDPrimaryActionButton,
  FDDialogActions,
  FDTextButton,
} from '@facet-wealth/design';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import categories from 'EventTracking/consts/categories';
import eventTypes from 'EventTracking/consts/eventTypes';
import eventSubTypes from 'EventTracking/consts/eventSubTypes';
import { navigateByRelationship } from 'Views/Page/Content/Templates';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

export const ModalActions = () => {
  const { onSubmit, resource } = useMetaLayoutContext();
  const { clearModalCollection, loadModalCollectionByLink } = useModalContext();
  const { refreshPageContentCollection, loadPageContentLink } = usePageContentContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();

  const onClickNavigate = (rel) => {
    logStandardizedEvent(categories.foundations, eventTypes.click, eventSubTypes.actionItemCTA, {
      eventProperties: {
        actionItemType: resource.attr('type'),
        actionItemName: resource.attr('name'),
        actionItemPillar: resource.attr('pillar'),
      },
    });
    return navigateByRelationship(rel, loadModalCollectionByLink, loadPageContentLink, clearModalCollection);
  };

  return (
    <FDDialogActions>
      <FDTextButton label="Cancel" onClick={clearModalCollection} />
      {resource.withRelationship(fr.relationships.detailNavigate.name, (rel) => {
        return (
          <FDPrimaryActionButton
            label={rel.meta('prompt')}
            onClick={async () => {
              await onClickNavigate(rel);
            }}
          />
        );
      }, () => {
        return (
          <FDPrimaryActionButton
            label={resource.metaField('completed').attr('prompt')}
            onClick={async () => {
              resource.attr('completed', 'true');
              await onSubmit();
              clearModalCollection();
              await refreshPageContentCollection();
            }}
          />
        );
      })}
    </FDDialogActions>
  );
};
